import React from "react";
import {
  Typography,
} from "@mui/material";

import BasePaper from "components/Base/BasePaper";
import ConversationLogForm from "./ConversationLogForm";

interface Props {
  notes: string;
  setNotes: (value: string) => void;
  onSubmit: () => void;
}

const ConversationLogFormSection: React.FC<Props> = ({
  notes,
  setNotes,
  onSubmit,
}) => {
  return (
    <BasePaper
      sx={{
        p: {
          xs: 1.5,
          sm: 2,
          md: 2.5,
        },
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 1,
          fontSize: {
            xs: "1rem",
            sm: "1.25rem",
          },
          lineHeight: 1.35,
        }}
      >
        Add notes about the conversation with this person
      </Typography>

      <ConversationLogForm
        notes={notes}
        onChange={{ setNotes }}
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
      />
    </BasePaper>
  );
};

export default ConversationLogFormSection;